<template>
  <div
    class="baseCardHeader flex flex-row justify-between items-center"
    :class="{
      'sticky-header': sticky,
      'elevation-1': elevation,
    }"
  >
    <slot />
  </div>
</template>

<script>
/**
 * @group InfoCard
 * Displays a title left aligned and a slot right aligned
 */
export default {
	props: {
		sticky: {
			type: Boolean,
			default: false
		},
		elevation: {
			type: Boolean,
			default: true
		},
		padding: {
			type: String,
			default: 'large',
			validator (value) {
				// The value must match one of these strings or be empty
				const sizes = ['none', 'xsmall', 'small', 'medium', 'large', 'xlarge'];
				return sizes.includes(value);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.box-shadow {
  box-shadow: 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.1);
}
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 1000;
}

.baseCardHeader {
  position: relative;
  background-color: #fff;
  color: #2E5B8B;
  padding: $padding-lg;
  border: .1rem solid #e6e8ed;
}

.baseCardHeader > * {
  margin: 0;
}

.elevation-1 {
  box-shadow: 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.1);
}

.elevation-2 {
  box-shadow: 0 0.1rem 1rem 0.4rem rgba(0, 0, 0, 0.1);
}

.elevation-3 {
  box-shadow: 0 0rem 1rem -0.1rem rgba(11, 27, 102, 0.3);
}
</style>
